<template>
  <button><slot/></button>
</template>

<script>
export default {
  name: 'SquareButton'
}
</script>


<style lang="scss" scoped>
button {
  border: 0;
  background: #E7E7E7;
  color: #737373;
  margin-bottom: 60px;
  width: 100%;
  font-weight: 300;
  font-size: 25px;
  display: block;
  padding: 21px;

}
</style>
